import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from '../../../auth/base/services/auth.service';
import { environment } from '../../../../environments/environment';
import { ApiError } from '../../../core/models/api-error.model';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  isDev = environment.dev;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((httpError: HttpErrorResponse) => {
        if (this.isDev) {
          this.displayError(httpError);
        }

        if (!AuthService.refreshing && httpError.status === 500) {
          this.handleInternalServerError(httpError.error);
        }

        return throwError(httpError);
      })
    );
  }

  private displayError(httpError: HttpErrorResponse) {
    console.log(httpError);
  }

  private handleInternalServerError(error: ApiError): void {}
}
